import React from 'react';
import { DEMO_CAMPAIGN_CHARACTERS } from '../../../../demoCampaign';

// Demo Campaign "page" — opened from the Open demo button on Home. Surfaces
// the same five launch options the demo supports (DM view + Li'ka + Ventyl +
// Eve + Khan). The "real" campaign detail view can't be reused here because the
// demo is synthetic (no Convex rows, no real roster query); this picker is
// a lighter standalone surface.

export const DemoCampaignModal = ({ theme, onClose, onEnter }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  return (
    <div
      role="dialog"
      aria-label="Demo Campaign"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 200,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 560,
          background: c.bgCardSolid,
          border: `1px solid ${c.borderPrimary}`,
          borderRadius: theme.effects?.borderRadiusLg || '12px',
          padding: 24,
          boxShadow: '0 18px 48px rgba(0,0,0,0.6)',
          color: c.textPrimary,
        }}
      >
        <h2 style={{
          margin: '0 0 4px',
          fontFamily: t.headingFamily,
          fontSize: '1.4rem',
          color: c.accentLight,
        }}>Demo Campaign</h2>
        <p style={{
          margin: '0 0 18px',
          color: c.textMuted,
          fontSize: '0.86rem',
          fontFamily: t.fontFamily,
        }}>Four pre-built characters running a sample table. Pick a view to enter.</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            type="button"
            onClick={() => onEnter({ role: 'dm' })}
            style={{
              padding: '12px 16px',
              background: c.accent,
              color: c.textOnAccent || '#000',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontFamily: t.fontFamily,
              fontWeight: 700,
              fontSize: '0.95rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              textAlign: 'left',
            }}
          >
            <span>👑 Enter as DM</span>
            <span style={{ fontSize: '0.78rem', opacity: 0.8 }}>full control</span>
          </button>

          <div style={{
            fontFamily: t.fontFamily,
            fontSize: '0.72rem',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: c.textMuted,
            margin: '8px 0 4px',
          }}>Or play as a character</div>

          {DEMO_CAMPAIGN_CHARACTERS.map((char) => (
            <button
              key={char.charId}
              type="button"
              onClick={() => onEnter({ role: 'player', charId: char.charId })}
              style={{
                padding: '11px 14px',
                background: 'rgba(255,255,255,0.04)',
                color: c.textPrimary,
                border: `1px solid ${c.borderLight}`,
                borderRadius: 6,
                cursor: 'pointer',
                fontFamily: t.fontFamily,
                fontSize: '0.92rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                textAlign: 'left',
              }}
            >
              <span style={{ fontWeight: 600 }}>{char.name}</span>
              <span style={{ fontSize: '0.78rem', color: c.textMuted }}>{char.subtitle}</span>
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 18 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '8px 14px',
              background: 'transparent',
              color: c.textSecondary,
              border: `1px solid ${c.borderLight}`,
              borderRadius: 4,
              cursor: 'pointer',
              fontFamily: t.fontFamily,
              fontSize: '0.86rem',
            }}
          >Close</button>
        </div>
      </div>
    </div>
  );
};
